import { FC, useContext } from "react"
import { Divider, Header, List } from "semantic-ui-react"
import { Login, Logout, User } from "../auth/auth"
import { useChild } from "../hooks"
import { Link } from "react-router-dom"

export const NavBar: FC = () => {

  const [userName] = useChild(useContext(User), 'userName')

  return <div><div style={{flexDirection: 'row', display: 'flex', alignContent: 'center', justifyContent: 'space-between'}}>
      <List horizontal>
        <List.Item><Link to='/'><Header as='h1'>OptiSpend</Header></Link></List.Item>
        <List.Item><a href="/products">Products</a></List.Item>
      </List>

      { userName ? <List horizontal>
        <List.Item><Link to={'/profile'}>{userName}</Link></List.Item>
        <List.Item><Link to={'/accounts'}>Scans</Link></List.Item>
        <List.Item><Logout/></List.Item>
      </List> : <Login /> }
    </div>
    <Divider/>
    </div>
}